const searchFormWrapper = document.querySelector(".header-actions .search-form");
if (searchFormWrapper) {
	srchBtn = searchFormWrapper.querySelector(".methodme-open-search-form-btn");
	subBtn = searchFormWrapper.querySelector(".methodme-submit-search-form-btn");
	clsBtn = searchFormWrapper.querySelector(".methodme-close-search-form-btn");
	const frm = searchFormWrapper.querySelector("form");
	const ipt = frm.querySelector("input");
	// console.log(document.querySelectorAll(".header-actions .search-form"));

	srchBtn.addEventListener("click", openSearch);

	clsBtn.addEventListener("click", (e) => {
		e.preventDefault();
		searchFormWrapper.classList.remove("opened");
		subBtn.style.zIndex = -5;
		subBtn.style.display = "none";
		srchBtn.style.display = "flex";
		ipt.value = "";
	});
}

function openSearch(e) {
	e.preventDefault();
	// console.log("opend");
	searchFormWrapper.classList.add("opened");
	searchFormWrapper.querySelector("input").focus();
	subBtn.style.zIndex = 15;
	subBtn.style.display = "flex";
	srchBtn.style.display = "none";

	// searchBtn.removeEventListener("click", openSearch);
}

/**
 * Mobile Search
 */
const searchFormWrapperMobile = document.querySelector(".header-actions .search-form.mobile-search");
// console.log(searchFormWrapperMobile);
if (searchFormWrapperMobile) {
	submitBtn = searchFormWrapperMobile.querySelector(".methodme-submit-search-form-btn");
	searchBtn = searchFormWrapperMobile.querySelector(".methodme-open-search-form-btn");
	closeBtn = searchFormWrapperMobile.querySelector(".methodme-close-search-form-btn");
	const form = searchFormWrapperMobile.querySelector("form");
	const input = form.querySelector("input");

	searchBtn.addEventListener("click", openSearchMobile);

	closeBtn.addEventListener("click", (e) => {
		e.preventDefault();
		searchFormWrapperMobile.classList.remove("opened");
		submitBtn.style.zIndex = -5;
		submitBtn.style.display = "none";
		input.value = "";
	});
}

function openSearchMobile(e) {
	e.preventDefault();
	searchFormWrapperMobile.classList.add("opened");
	searchFormWrapperMobile.querySelector("input").focus();
	submitBtn.style.zIndex = 5;
	submitBtn.style.display = "flex";
	// searchBtn.removeEventListener("click", openSearchMobile);
}
